import React from 'react';
import { Grid, TextareaAutosize } from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import CustomTextField from '../formFields/textField';
import LoaderButton from '../loaderButton/loaderButton';
import { settingFormScheme } from '../yup/scheme';
import PageHeader from 'src/components/pageHeader/PageHeader';

const SettingLogicForm = ({ onSubmit, loading, data }) => {
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(settingFormScheme),
    defaultValues: { ...data },
  });
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Number Of Free Miles'}
            type={'number'}
            controller={{
              name: 'noOfFreeMiles',
              control: control,
              errors: errors.noOfFreeMiles,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Base Charge (£)'}
            type={'number'}
            controller={{
              name: 'priceOfBaseCharge',
              control: control,
              errors: errors.priceOfBaseCharge,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Per Mile Price (£)'}
            type={'number'}
            controller={{
              type: 'number',
              name: 'priceOfPerMile',
              control: control,
              errors: errors.priceOfPerMile,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Accept Marketing Discount (%) (DEFUNCT)'}
            type={'number'}
            controller={{
              name: 'acceptMarketing',
              control: control,
              errors: errors.acceptMarketing,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Per Stop Charge (applied at stop #3 and beyond) (£)'}
            type={'number'}
            controller={{
              name: 'extraStopCharge',
              control: control,
              errors: errors.extraStopCharge,
            }}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'3 items or less discount (%)'}
            type={'number'}
            controller={{
              name: 'threeItems',
              control: control,
              errors: errors.threeItems,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <PageHeader pageTitle={'Up-Sell Price Settings'} />
        </Grid>
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Per Extra Man Increase (%)'}
            type={'number'}
            controller={{
              name: 'jobPercentage',
              control: control,
              errors: errors.jobPercentage,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <PageHeader pageTitle={'Cross-Sell Price Settings'} />
        </Grid>
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Pro External Window Clean'}
            type={'number'}
            controller={{
              name: 'jobPercentage',
              control: control,
              errors: errors.jobPercentage,
            }}
          />
          <CustomTextField
            label={'Pro Garden Refresh'}
            type={'number'}
            controller={{
              name: 'jobPercentage',
              control: control,
              errors: errors.jobPercentage,
            }}
          />
          <CustomTextField
            label={'Pro Indoor Deep Clean'}
            type={'number'}
            controller={{
              name: 'jobPercentage',
              control: control,
              errors: errors.jobPercentage,
            }}
          />
          <CustomTextField
            label={'Pro Oven Clean'}
            type={'number'}
            controller={{
              name: 'jobPercentage',
              control: control,
              errors: errors.jobPercentage,
            }}
          />
          <CustomTextField
            label={'Surface And Carpets'}
            type={'number'}
            controller={{
              name: 'jobPercentage',
              control: control,
              errors: errors.jobPercentage,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <PageHeader pageTitle={'Driver Settings'} />
        </Grid>
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Driver admin fee (%)'}
            type={'number'}
            controller={{
              name: 'jobPercentage',
              control: control,
              errors: errors.jobPercentage,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <PageHeader pageTitle={'Booking Form Settings'} />
        </Grid>
        <Grid item xs={12} sm={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <label>Step 1 Script (js, html etc.)</label>
          <TextareaAutosize
            {...register('bookingFormStep1')}
            minRows={3}
            maxRows={3}
            style={{
              minWidth: '100%',
              maxWidth: '100%',
              height: '70px',
              maxHeight: '100px',
              borderRadius: '8px',
              padding: '8px',
              fontSize: '16px',
            }}
            className="scriptArea"
          />
          {errors.bookingFormStep1 && (
            <p style={{ color: 'red', fontSize: '12px' }}>{errors.bookingFormStep1.message}</p>
          )}
        </Grid>
        <Grid item xs={12} sm={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <label>Step 2 Script (js, html etc.)</label>
          <TextareaAutosize
            {...register('bookingFormStep2')}
            minRows={3}
            maxRows={3}
            style={{
              minWidth: '100%',
              maxWidth: '100%',
              height: '70px',
              maxHeight: '100px',
              borderRadius: '8px',
              padding: '8px',
              fontSize: '16px',
            }}
            className="scriptArea"
          />
          {errors.bookingFormStep2 && (
            <p style={{ color: 'red', fontSize: '12px' }}>{errors.bookingFormStep2.message}</p>
          )}
        </Grid>
        <Grid item xs={12} sm={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <label>Step 3 Script (js, html etc.)</label>
          <TextareaAutosize
            {...register('bookingFormStep3')}
            minRows={3}
            maxRows={3}
            style={{
              minWidth: '100%',
              maxWidth: '100%',
              height: '70px',
              maxHeight: '100px',
              borderRadius: '8px',
              padding: '8px',
              fontSize: '16px',
            }}
            className="scriptArea"
          />
          {errors.bookingFormStep3 && (
            <p style={{ color: 'red', fontSize: '12px' }}>{errors.bookingFormStep3.message}</p>
          )}
        </Grid>
        <Grid item xs={12} sm={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <label>Step 4 (Summary) Script (js, html etc.)</label>
          <TextareaAutosize
            {...register('bookingFormStep4')}
            minRows={3}
            maxRows={3}
            style={{
              minWidth: '100%',
              maxWidth: '100%',
              height: '70px',
              maxHeight: '100px',
              borderRadius: '8px',
              padding: '8px',
              fontSize: '16px',
            }}
            className="scriptArea"
          />
          {errors.bookingFormStep4 && (
            <p style={{ color: 'red', fontSize: '12px' }}>{errors.bookingFormStep4.message}</p>
          )}
        </Grid>

        {/* extra clean 
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Pro Indoor Deep Clean'}
            type={'number'}
            controller={{
              name: 'proIndoorDeepClean',
              control: control,
              errors: errors.proIndoorDeepClean,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Surface And Carpets'}
            type={'number'}
            controller={{
              name: 'surfaceAndCarpets',
              control: control,
              errors: errors.surfaceAndCarpets,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Pro Garden Refresh'}
            type={'number'}
            controller={{
              name: 'proGardenRefresh',
              control: control,
              errors: errors.proGardenRefresh,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Pro Oven Clean'}
            type={'number'}
            controller={{
              name: 'proOvenClean',
              control: control,
              errors: errors.proOvenClean,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <CustomTextField
            label={'Pro External Window Clean'}
            type={'number'}
            controller={{
              name: 'proExternalWindowClean',
              control: control,
              errors: errors.proExternalWindowClean,
            }}
          />
        </Grid> */}
        <Grid item xs={12} sm={12}>
          <LoaderButton loading={loading} buttonText={'Update'} type="submit" />
        </Grid>
      </Grid>
    </form>
  );
};

export default SettingLogicForm;
